import { BrandInterface, DefaultBrand } from "../Brand/Brand.Interface";

export interface EmbedConfig {
  brand: BrandInterface;

  // text?:string
  // textBackground?:string

  // userBubbleBackground?:string
  // userBubbleText?:string

  // botBubbleBackground?:string
  // botBubbleText?:string

  // primaryBackground?:string
  // primaryText?:string
  // primaryHover?:string
  // primaryHoverText?:string
  // primaryActive?:string
  // primaryActiveText?:string

  // secondaryBackground?:string
  // secondaryText?:string
  // secondaryHover?:string
  // secondaryHoverText?:string
  // secondaryActive?:string
  // secondaryActiveText?:string

  orgId: number;
  botName: string;
  language: string;
  startOnQuest?: string;
  position: string;
  startConversationClosed: boolean;
  startOpen: boolean;
  loadPastMessages: boolean;
  avatarURL: string;
  showAvatarInHeader: boolean;
  showAvatarWithTimestamp: boolean;
  showAvatar: boolean;
  collapsedStyle: string;
  headerText: string;
  dotText: string;
  linkTarget: string;
  primaryFont: string;
  secondaryFont: string;

  // headerColor: string
  // bodyBackground: string
  // userBubbleBackground: string
  // userBubbleColor: string
  // botBubbleBackground: string
  // botBubbleColor: string
  // timestampColor: string
  // formBackground: string
  // formColor: string
  // linkColor: string
  // linkHoverColor: string
  // sendButtonBackground: string
  // sendButtonColor: string
  // sendButtonHoverBackground: string
  // sendButtonHoverColor: string
  // sendButtonActiveBackground: string
  // sendButtonActiveColor: string
  // primaryButtonBackground: string
  // primaryButtonColor: string
  // primaryButtonHoverBackground: string
  // primaryButtonHoverColor: string
  // primaryButtonActiveBackground: string
  // primaryButtonActiveColor: string
  // secondaryButtonBackground: string
  // secondaryButtonColor: string
  // secondaryButtonHoverBackground: string
  // secondaryButtonHoverColor: string
  // secondaryButtonActiveBackground: string
  // secondaryButtonActiveColor: string
  // tertiaryButtonBackground: string
  // tertiaryButtonColor: string
  // tertiaryButtonHoverBackground: string
  // tertiaryButtonHoverColor: string
  // tertiaryButtonActiveBackground: string
  // tertiaryButtonActiveColor: string

  showCTA?: boolean;
  ctaDelay?: number;
  ctaTitle?: string;
  ctaImageURL?: string;
  ctaBody?: string;
  ctaStartOnQuest?: string;

  dotDesktopLeftOffset?: number;
  dotDesktopRightOffset?: number;
  bodyDesktopLeftOffset?: number;
  bodyDesktopRightOffset?: number;

  preloadVariables?: { [key: string]: string };
}
export const EmbedConfigForBot = function (bot: any) {
  var config = DefaultEmbedConfig({});
  config.orgId = bot.id;
  config.headerText = "Chat with <b>" + bot.get("name") + "</b>";
  config.dotText = "Chat with <b>" + bot.get("name") + "</b>";
  return config;
};

export function DefaultEmbedConfig(config: any): EmbedConfig {
  const defaultConfig: any = {
    orgId: "",

    language: "en",
    startOnQuest: undefined,
    position: "bottom-right",
    startConversationClosed: false,
    startOpen: false,
    loadPastMessages: false,
    avatarURL: "https://swivl-uploads-production.s3.amazonaws.com/54f85f16d7d3583e4dc880367ff9fdae_avatar.png",
    showAvatarInHeader: false,
    showAvatarWithTimestamp: true,
    headerText: "Chat with <b>My Bot</b>",
    dotText: "Questions?",
    linkTarget: "_blank",
    primaryFont: "'Poppins', sans-serif;",
    secondaryFont: "'Poppins', sans-serif;",
    loadPastMessagesColor: "#DAD3D0",
    loadPastMessagesHoverColor: "#C3BCB9",
    loadPastMessagesActiveColor: "#A8A4A2",
    loadPastMessagesSpinnerFill: "#f67902",

    brand: { ...DefaultBrand },
    showAvatar: true,
    collapsedStyle: "dot"
  };

  for (let key in defaultConfig) {
    if (defaultConfig.hasOwnProperty(key) && !config[key]) {
      config[key] = defaultConfig[key];
    }
  }

  return config;
}

function hexToRgb(hex: string): any {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
        a: 1
      }
    : null;
}

function elementCSS(prefix: string, baseName: string, background?: string, color?: string) {
  return prefix + " " + baseName + " { \n   background: " + background + ";\n   color: " + color + ";\n }\n\n";
}

function buttonCSS(
  prefix: string,
  baseName: string,
  background?: string,
  color?: string,
  hoverBackground?: string,
  hoverColor?: string,
  activeBackground?: string,
  activeColor?: string
) {
  var css = "";
  const name = prefix + " " + baseName;
  css += name + " { \n   background: " + background + ";\n   color: " + color + ";\n }\n";
  css += name + ":hover, " + name + ".hover  { \n   background: " + hoverBackground + ";\n   color: " + hoverColor + ";\n }\n";
  css += name + ":active, " + name + ".active { \n   background: " + activeBackground + ";\n   color: " + activeColor + ";\n }\n\n";
  return css;
}

function linkCSS(prefix: string, baseName: string, color?: string, hoverColor?: string, activeColor?: string) {
  var css = "";
  css += prefix + " " + baseName + " { \n   color: " + color + ";\n }\n";
  css += prefix + " " + baseName + ":hover { \n   color: " + hoverColor + ";\n }\n";
  css += prefix + " " + baseName + ":active { \n   color: " + activeColor + ";\n }\n\n";
  return css;
}

export function EmbedCSS(config: EmbedConfig, prefixVar: string) {
  const prefix = typeof prefixVar != "undefined" ? prefixVar : "#swivl-ec";
  const defaultConfig = DefaultEmbedConfig({});

  const brand: Omit<BrandInterface, "createdAt" | "updatedAt"> = { ...DefaultBrand, ...config?.brand };
  brand.theme = { ...DefaultBrand.theme, ...brand.theme };

  var css = "\n";

  if (config.primaryFont) {
    css += prefix + " .swivl-mainFont { \n   font-family: " + config.primaryFont + ";\n }\n\n";
  } else {
    css += prefix + " .swivl-mainFont { \n   font-family: " + defaultConfig.primaryFont + ";\n }\n\n";
  }

  if (config.secondaryFont) {
    css += prefix + " .swivl-secondaryFont { \n   font-family: " + config.secondaryFont + ";\n }\n\n";
  } else {
    css += prefix + " .swivl-secondaryFont { \n   font-family: " + defaultConfig.secondaryFont + ";\n }\n\n";
  }

  css += elementCSS(prefix, ".swivl-header", brand.theme?.headerBackground, brand.theme?.headerColor);

  css += prefix + " .swivl-loadPastMessages        { \n   color: " + brand.theme.primaryHover + ";\n  }\n";
  css += prefix + " .swivl-loadPastMessages:hover  { \n   color: " + brand.theme.primaryHoverText + ";\n }\n";
  css += prefix + " .swivl-loadPastMessages:active { \n   color: " + brand.theme.primaryActive + ";\n }\n\n";

  css += prefix + " .swivl-loadingPastMessagesSpinner { \n   fill: " + brand.theme.primaryHover + ";\n }\n\n";
  css += prefix + " .swivl-loadingPastMessages { \n   color: " + brand.theme.primaryHover + ";\n }\n\n";

  // We need to set the gradients to the body color for Carousels.
  var bodyRGBA = hexToRgb("#ffffff");
  const opaqueBody = "rgba(" + bodyRGBA.r + ", " + bodyRGBA.g + "," + bodyRGBA.b + ",1)";
  const transparentBody = "rgba(" + bodyRGBA.r + ", " + bodyRGBA.g + "," + bodyRGBA.b + ",0)";
  css += prefix + " .swivl-body { \n   background: " + opaqueBody + ";\n }\n\n";
  css +=
    prefix +
    " .swivl-gradientLeft { \n   background: " +
    brand.theme.primaryBackground +
    ";\n  background: linear-gradient(90deg, " +
    opaqueBody +
    " 0%, " +
    transparentBody +
    " 100%);\n }\n\n";
  css +=
    prefix +
    " .swivl-gradientRight { \n   background: " +
    brand.theme.primaryBackground +
    ";\n  background: linear-gradient(90deg, " +
    transparentBody +
    " 0%, " +
    opaqueBody +
    " 100%);\n }\n\n";

  css += elementCSS(prefix, ".swivl-userBubble", brand.theme.userBubbleBackground, brand.theme.userBubbleText);

  css += elementCSS(prefix, ".swivl-botBubble", brand.theme.botBubbleBackground, brand.theme.botBubbleText);

  css += prefix + " .swivl-timestamp { \n   color: " + brand.theme.text + "; \n opacity:0.80;\n }\n\n";

  // if (config.formBackground && config.formColor) {
  //   css += elementCSS(prefix, '.swivl-form', config.formBackground, config.formColor)
  // } else {
  //   css += elementCSS(prefix, '.swivl-form', defaultConfig.formBackground, defaultConfig.formColor)
  // }
  // if (config.formBackground) {
  //   css +=
  //     prefix + ' .swivl-mainBackground { \n   background: ' + config.formBackground + ';\n }\n\n'
  // }
  //SEND BUTTON

  css += buttonCSS(
    prefix,
    ".swivl-primaryButton",
    brand.theme?.primaryBackground,
    brand.theme?.primaryText,
    brand.theme?.primaryHover,
    brand.theme?.primaryHoverText,
    brand.theme?.primaryActive,
    brand.theme?.primaryActiveText
  );

  css += prefix + " .swivl-svgButton svg        { \n   fill: " + brand.theme.primaryBackground + ";\n  }\n";
  css += prefix + " .swivl-svgButton:hover svg  { \n   fill: " + brand.theme.primaryText + ";\n }\n";
  css += prefix + " .swivl-svgButton:active svg { \n   fill: " + brand.theme.primaryActive + ";\n }\n\n";

  css += prefix + " .swivl-svgButton.hover svg  { \n   fill: " + brand.theme.primaryHover + ";\n }\n";
  css += prefix + " .swivl-svgButton.active svg { \n   fill: " + brand.theme.primaryActive + ";\n }\n\n";

  css += `${prefix} .swivl-fillPrimary          { fill: ${brand.theme.primaryBackground}       ;}\n`;
  css += `${prefix} .swivl-fillPrimary:hover    { fill: ${brand.theme.primaryHover}  ;}\n`;
  css += `${prefix} .swivl-fillPrimary:active   { fill: ${brand.theme.primaryActive} ;}\n`;
  css += `${prefix} .swivl-fillPrimary.hover    { fill: ${brand.theme.primaryHover}  ;}\n`;
  css += `${prefix} .swivl-fillPrimary.active   { fill: ${brand.theme.primaryActive} ;}\n`;
  css += `${prefix} .swivl-fillPrimary.disabled { fill: ${brand.theme.primaryActive}; opacity: 0.5;}\n`;

  css += `${prefix} .swivl-primaryBorderHover:hover    { border-color: ${brand.theme.primaryBackground}  ;}\n`;
  css += `${prefix} .swivl-primaryBorderHover:active   { border-color: ${brand.theme.primaryHover} ;}\n`;

  css += `${prefix} .swivl-primaryBackgroundHover:hover    { background-color: ${brand.theme.primaryHover}  ;}\n`;
  css += `${prefix} .swivl-primaryBackgroundHover:active   { background-color: ${brand.theme.primaryActive} ;}\n`;
  css += `${prefix} .swivl-primaryTextHover:hover    { color: ${brand.theme.primaryHoverText}  ;}\n`;
  css += `${prefix} .swivl-primaryTextHover:active   { color: ${brand.theme.primaryActiveText} ;}\n`;

  css += `${prefix} .swivl-disabled   { filter: saturate(20%) opacity(35%) }\n`;

  //SECONDARY BUTTON
  css += buttonCSS(
    prefix,
    ".swivl-secondaryButton",
    brand.theme?.secondaryBackground,
    brand.theme?.secondaryText,
    brand.theme?.secondaryHover,
    brand.theme?.secondaryHoverText,
    brand.theme?.secondaryActive,
    brand.theme?.secondaryActiveText
  );

  css += linkCSS(prefix, ".swivl-linkContainer a", brand.theme?.primaryBackground, brand.theme?.primaryActive, brand.theme?.primaryHover);
  // css += buttonCSS(
  //   prefix,
  //   '.swivl-linkColorBackground',
  //   config.linkColor,
  //   '#FFF',
  //   config.linkHoverColor,
  //   '#FFF',
  //   config.linkHoverColor,
  //   '#FFF'
  // )

  return css;
}
